/**
 * Conversion from the parsed-URDF wire format to the store's types.
 *
 * The server sends what skrobot's parse_urdf_content returns, in
 * snake_case, over two routes: the `urdf_for_config_result` WebSocket
 * message when the wizard is entered from the builder, and
 * `POST /api/configure/parse-urdf` when a URDF is pasted or uploaded.
 * Both land in the same store, which uses camelCase like the rest of the
 * TypeScript.
 */

import type { JointInfo, LinkInfo } from "./ConfigureStore";

export interface WireJoint {
  name: string;
  type: string;
  parent_link: string;
  child_link: string;
  axis: [number, number, number];
  lower_limit: number;
  upper_limit: number;
  velocity_limit: number;
  effort_limit: number;
}

export interface WireLink {
  name: string;
  has_visual: boolean;
  has_collision: boolean;
  has_inertial: boolean;
}

export function toJointInfo(joint: WireJoint): JointInfo {
  return {
    name: joint.name,
    type: joint.type,
    parentLink: joint.parent_link,
    childLink: joint.child_link,
    axis: joint.axis,
    lowerLimit: joint.lower_limit,
    upperLimit: joint.upper_limit,
    velocityLimit: joint.velocity_limit,
    effortLimit: joint.effort_limit,
  };
}

export function toLinkInfo(link: WireLink): LinkInfo {
  return {
    name: link.name,
    hasVisual: link.has_visual,
    hasCollision: link.has_collision,
    hasInertial: link.has_inertial,
  };
}
